/* Keep the app's price and purchase mechanics; mirror the selected offer into clear copy. */

if(!customElements.get('nc-selection-summary'))customElements.define('nc-selection-summary',class extends HTMLElement{

 connectedCallback(){

  this.host=this.closest('.product__info-container');this.widget=this.host?.querySelector('section-store--bundle-block');if(!this.widget)return;

  this.abort=new AbortController();this.sync=()=>this.update();

  const attach=()=>{if(!this.isConnected||!this.widget.shadowRoot)return;this.root=this.widget.shadowRoot;

   this.root.addEventListener('pointerdown',()=>{this.touched=true;},{signal:this.abort.signal});

   this.root.addEventListener('keydown',()=>{this.touched=true;},{signal:this.abort.signal});

   this.root.addEventListener('change',()=>requestAnimationFrame(this.sync),{signal:this.abort.signal});

   this.observer=new MutationObserver(this.sync);this.observer.observe(this.root,{childList:true,subtree:true,characterData:true});this.update();};

  customElements.whenDefined('section-store--bundle-block').then(attach);

 }

 update(){

  const options=[...this.root.querySelectorAll('.bundle-option.volume-discount')];if(!options.length)return;

  const input=el=>el.querySelector('.bundle-option-input');

  if(!this.initialized){
   const handle=this.dataset.handle;
   const saved=history.state?.ncOfferSelection;
   const intent={'one-duo':1,'two-duos':2,'four-duos':4}[new URLSearchParams(location.search).get('offer')];
   const desired=handle==='meridian-duo'?(saved?.handle===handle&&[1,2,4].includes(saved.quantity)?saved.quantity:intent||2):1;
   const match=options.find(el=>Math.max(1,el.querySelectorAll('.product-variant-selectors .selector-wrapper').length)===desired);
   if(!match)return;
   this.initialized=true;
   if(!this.touched&&!input(match)?.checked)input(match)?.click();
  }

  const setText=(el,text)=>{if(el&&el.textContent!==text)el.textContent=text;};

  const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency:this.dataset.currency||'AUD',currencyDisplay:'narrowSymbol',maximumFractionDigits:n%100?2:0}).format(n/100);

  const quantity=el=>Math.max(1,el.querySelectorAll('.product-variant-selectors .selector-wrapper').length);

  const getPrice=el=>Math.round(Number(el.querySelector('.price-total .discounted')?.textContent.replace(/[^0-9.]/g,''))*100);

  const isSet=/duo|pour|setting|full-table/.test(this.dataset.handle),person=this.dataset.person==='true';
  const converted=this.dataset.currency&&this.dataset.currency!=='AUD';
  if(converted)setText(this.host.querySelector('.nc-quantity-note'),'Savings compare the same pieces bought individually.');

  for(const el of options){const q=quantity(el),count=q*Number(this.dataset.pieces),price=getPrice(el),separate=q*Number(this.dataset.separate);

   setText(el.querySelector('.title'),isSet?`${q} ${q===1?'set':'sets'} \u00b7 ${count} pieces`:`${q} ${this.dataset.handle==='meridian-cutlery'?'cutlery '+(q===1?'set':'sets'):q===1?'piece':'pieces'}`);

   setText(el.querySelector('.subtitle'),this.dataset.handle==='meridian-duo'?`${q} ${q===1?'plate':'plates'} + ${q} ${q===1?'bowl':'bowls'}`:person?`For ${q} ${q===1?'person':'people'}`:'Selected total shown');

   setText(el.querySelector('.badge.active'),q>1?'More for your table':'');

   if(isSet&&Number.isFinite(price)&&separate>price){setText(el.querySelector('.title-badge'),`Save ${money(separate-price)}`);const original=el.querySelector('.price-total .original');setText(original,money(separate));if(original)original.setAttribute('aria-label','Price of individual pieces');}

   const label=el.querySelector('.bundle-option-radio-label');if(label){label.tabIndex=0;label.setAttribute('role','radio');label.setAttribute('aria-checked',String(!!input(el)?.checked));if(!label.dataset.ncKeys){label.dataset.ncKeys='true';label.addEventListener('keydown',event=>{if([' ','Enter'].includes(event.key)){event.preventDefault();input(el)?.click();this.update();}if(['ArrowDown','ArrowUp','ArrowRight','ArrowLeft'].includes(event.key)){event.preventDefault();const next=options[(options.indexOf(el)+(['ArrowDown','ArrowRight'].includes(event.key)?1:options.length-1))%options.length];input(next)?.click();next.querySelector('label')?.focus();this.update();}});}}

  }

  const selected=options.find(el=>input(el)?.checked)||options[0],q=quantity(selected),total=getPrice(selected);if(!Number.isFinite(total)||total<=0)return;

  const selectionKey=q+':'+total;

  if(this.touched&&this.lastSelection&&this.lastSelection!==selectionKey&&window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()){

   try{window.Shopify?.analytics?.publish?.('nc_quantity_selected',{handle:this.dataset.handle,quantity:q,value:total/100,currency:this.dataset.currency});}catch{}

  }

  if(this.touched){try{history.replaceState({...history.state,ncOfferSelection:{handle:this.dataset.handle,quantity:q}},'');}catch{}}
  if(this.lastSelection!==selectionKey){
   this.dispatchEvent(new CustomEvent('nc:offer-state',{bubbles:true,detail:{handle:this.dataset.handle,quantity:q,total,currency:this.dataset.currency}}));
  }
  this.lastSelection=selectionKey;
  this.dataset.selectedQuantity=String(q);this.dataset.selectedTotal=String(total);

  const separate=q*Number(this.dataset.separate),price=this.host.querySelector('[id^="price-"]');

  if(price){setText(price.querySelector('[data-nc-current-price]'),money(total));setText(price.querySelector('[data-nc-separate-price]'),money(separate));const comparison=price.querySelector('[data-nc-price-comparison]');if(comparison)comparison.hidden=separate<=total;}

 }

 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}

});

